import {
  Link as ChakraLink,
  LinkProps as ChakraLinkProps
} from '@chakra-ui/react';
import { forwardRef, LegacyRef } from 'react';
import { Link as RouterLink, LinkProps as RouterlinkProps } from 'react-router';

export type LinkProps = ChakraLinkProps &
  Omit<RouterlinkProps, 'to'> &
  Partial<Pick<RouterlinkProps, 'to'>>;

export const Link = forwardRef(function Link(
  props: LinkProps,
  ref
): JSX.Element {
  return (
    <ChakraLink
      as={props.isExternal ? 'a' : RouterLink}
      {...props}
      ref={ref as LegacyRef<HTMLAnchorElement>}
      width="fit-content"
    />
  );
});
